export const state = () => ({
  transparent: false,
  whiteStyle: false,
});

export const mutations = {
  setNav(_state, opt = { transparent: false, whiteStyle: false }) {
    _state.whiteStyle = opt.whiteStyle;
    _state.transparent = opt.transparent;
  },
};



// WEBPACK FOOTER //
// ./src/store/nav.js